import React, { useEffect, useState } from 'react';
import Cta from '../../components/Cta'

import DealService from '../../services/DealService'
import { useUser } from '../../providers/UserProvider';

const FeaturedDeals = (props) => {
  //const deals = props.deals || [];
  let logoClass = `w-16 h-16 md:w-20 md:h-20 p-2 flex justify-center rounded-2xl group-hover:opacity-75`;
  let containerClass = `relative border p-2 md:p-8 rounded-lg flex flex-col justify-center items-center overflow-hidden w-56`;

  const [ deals, setFeaturedDeals ] = useState([]);
  const [ user, userDispatch ] = useUser();

  useEffect(() => {
    DealService.getDealCollections("featured", 20).then((response) => {
      let payload = response.data.data;

      if (payload.deals) {
        let shuffled = payload.deals.sort(() => 0.5 - Math.random());
        setFeaturedDeals(shuffled.slice(0,3));
      }
    });
  }, []);
  

  return (
    <div className="relative">
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gray-100" />
      <div className="w-full">
        <div className="relative sm:overflow-hidden">
          <div className="absolute inset-0">
            <img
              className="h-full w-full object-top object-cover"
              src="/images/homepage/homepage_9@2x.png"
              alt="People working on laptops"
            />
            <div className="absolute inset-0 bg-gray-400 mix-blend-multiply" />
          </div>

          <div className="relative mx-auto md:max-w-[500px] xl:max-w-full xl:container xl:w-full grid grid-cols-1 xl:grid-cols-2 items-center justify-center px-4 md:px-0 xl:space-x-8 py-16 xl:py-32">
            <div className="text-center xl:text-left ">
              <h1 className="font-secondary text-headline-1 md:text-headline-1-md 2xl:text-headline-1-lg text-white" style={{ marginBottom: '-1rem'}}>
                <span className="block xl:inline">Saving you money on everyday business expenses</span>
              </h1>
              <p className="font-primary text-white text-body-1 md:text-body-1-md 2xl:text-body-1-lg mt-6 xl:max-w-3xl">Small business members deserve big business savings</p>
              <div className="mt-5 lg:mt-6 sm:flex sm:justify-center xl:justify-start">
                <div className="rounded-md">
                  { user.loggedIn && 
                    <Cta label="View Offers" href="/marketplace" style='style-2' />
                  }
                  { !user.loggedIn && 
                    <Cta label="Join the Convoy" href="/register" style='style-2' />
                  }
                </div>
              </div>
            </div>

            <a href={ (!user.loggedIn)? "/register" : "/marketplace" } className="cursor-pointer grid grid-cols-3 mx-auto max-w-[520px] lg:max-w-full bg-grey-featured rounded-lg mt-6">
            { deals.map((deal) => (
              <div
                key={deal.id}
                className="relative px-2 py-4 md:p-8 flex flex-col items-center text-center overflow-hidden"
              >
                <div 
                  className={logoClass}
                  style={ { backgroundColor: `#${deal.logoColor || 'ffffff' }` } }
                >
                  <img
                    src={deal.vendor.image}
                    alt={`${deal.vendor.name} logo`}
                    className="object-center object-contain"
                  />
                </div>
                <div className="mt-4">
                  <h3 className="font-deal-card-title text-xs 2xl:text-md text-gray-900">
              {deal.vendor.name}: {deal.name}
                  </h3>
                </div>

                <div className="hidden lg:block mt-auto">
                  <p style={{ overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }} className="font-deal-card-desc text-xxs 2xl:text-xs text-black mt-4">{deal.vendor.desc}</p>
                </div>
              </div>
            )) }
            </a>

          </div>
        </div>
      </div>
    </div>
  )
}

export { FeaturedDeals }
